/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.academy.learning.events.rpc.LearningEventUserRpc
 */

export const getEventsRpc = {
  serviceName: 'com.hubspot.academy.learning.events.rpc.LearningEventUserRpc',
  rpcName: 'getEvents',
  auth: 'app',
  fingerprint: 'CfCjJ96k_yK5gzI97TF2ljAWAf6YdFo-',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getEventByIdRpc = {
  serviceName: 'com.hubspot.academy.learning.events.rpc.LearningEventUserRpc',
  rpcName: 'getEventById',
  auth: 'app',
  fingerprint: '4IYhRG_IfYI6e_0qqpdi1zAWAf6YdFo-',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};